/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExpectedRevisionRequest
 */
export interface ExpectedRevisionRequest {
    /**
     * 
     */
    expected_revision: number;
}

/**
 * Check if a given object implements the ExpectedRevisionRequest interface.
 */
export function instanceOfExpectedRevisionRequest(value: object): value is ExpectedRevisionRequest {
    if (!('expected_revision' in value) || value['expected_revision'] === undefined) return false;
    return true;
}

export function ExpectedRevisionRequestFromJSON(json: any): ExpectedRevisionRequest {
    return ExpectedRevisionRequestFromJSONTyped(json, false);
}

export function ExpectedRevisionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExpectedRevisionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'expected_revision': json['expected_revision'],
    };
}

export function ExpectedRevisionRequestToJSON(json: any): ExpectedRevisionRequest {
    return ExpectedRevisionRequestToJSONTyped(json, false);
}

export function ExpectedRevisionRequestToJSONTyped(value?: ExpectedRevisionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expected_revision': value['expected_revision'],
    };
}

